export const localDate = () => new Date().toLocaleDateString("en-CA");
